import React from 'react';
import SavingButton from 'library/components/saving-button';
import AdjectiveRow from 'apps/pathways/components/survey/list/adjective-row';

export default class ListVersion extends React.Component {
    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll)
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
    }

    handleScroll = (e) => {
        this.props.onProgress((document.body.scrollTop / (document.body.scrollHeight - window.innerHeight)) * 100);
    }
    mapAdjectives = (adjective) => {
        const { responses, mode='real', toggleActive=()=>{}, preferred_language } = this.props;
        const { real=false, ideal=false } = responses[adjective.id] || {};

        return (
            <AdjectiveRow language={preferred_language} mode={mode} key={adjective.id} adjective={adjective} real={real} ideal={ideal} toggleActive={toggleActive} />
        )
    }

    get nextMode() {
        if (this.props.mode === 'real') {
            return 'ideal_instructions';
        }
        return 'complete';
    }

    render() {
        const { mode, adjectives, onComplete, saving } = this.props;
        return (
            <div className="survey-list">
                <div className="survey-header">
                    <div className="survey-adjective-header">
                        Select words that describe<br />
                        <strong>how you are</strong>
                    </div>
                    {
                        mode === 'ideal'
                            ? (
                                <div className="survey-adjective-header">
                                    Change your selections for<br />
                                    <strong>how you want to be</strong>
                                </div>
                            )
                            : null
                    }
                </div>
                { adjectives.map(this.mapAdjectives)}
                <div className="survey-footer">
                    <SavingButton saving={saving} onClick={()=>onComplete(this.nextMode)}>Next <i className="icon-angle-right" /></SavingButton>
                </div>
            </div>
        )
    }
}
